import { render, staticRenderFns } from "./off_shelf_channel_dialog.vue?vue&type=template&id=039abef4&scoped=true"
import script from "./off_shelf_channel_dialog.vue?vue&type=script&lang=js"
export * from "./off_shelf_channel_dialog.vue?vue&type=script&lang=js"
import style0 from "./off_shelf_channel_dialog.vue?vue&type=style&index=0&id=039abef4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039abef4",
  null
  
)

export default component.exports